import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-39346442"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container"
};
const _hoisted_3 = {
  class: "tree__container mg-b--15"
};
const _hoisted_4 = {
  class: "mg-l--25"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mg-r--25 aside__cursor"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-ic_list"
})], -1));

const _hoisted_6 = {
  id: "columntree"
};
const _hoisted_7 = {
  class: "table__container"
};
const _hoisted_8 = {
  class: "footer-btn"
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import { useRouter } from 'vue-router';
import { transferTime, getItemByProp } from '@/utils/tools';
import { getLiveChannelListApi, getLanguageListApi, getEnListApi, addCategoryChannelApi } from '@/api/live';
import { nextTick, onMounted, watch } from 'vue';
import { useCommon } from '@/store/useCommon';
import { ElMessage } from 'element-plus';
import { getCurrentTime } from '@/utils/timeFormat';
import { useI18n } from 'vue-i18n';
import { getUserByCidApi } from '@/api/authority';
import { useBrandsByUser } from '@/utils/cacheData'; // 表格列排序

const __default__ = {
  name: 'AddChannelToContent'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    pageParams: null,
    returnBackFn: null
  },

  setup(__props) {
    const props = __props;
    const headerConfig = ref({
      title: '添加频道',
      btnList: [{
        label: '返回',
        func: () => {
          props.returnBackFn();
        }
      }]
    });
    const {
      t
    } = useI18n();
    const router = useRouter();
    const isShowAside = ref(true);
    const loading = ref(true);
    const isVnoAccount = useCommon().userData.roles.some(item => /VNO/ig.test(item)) || useCommon().userData.roles.includes('CUSTOMER_SN'); //区分是否为vno运营商账号

    const categories = ref([]);
    const tableWarpRef = ref(null);
    const sortParams = reactive({
      orderBy: undefined,
      orderType: undefined
    });
    const tableRef = ref(); //运营商id vno账号下有一个id，否则就是根据品牌的下拉框来选  注意：后续端口用到cpspId时，如果不是vno账号要重新从productOperationsCid获取
    // productOperationsCid来源:\src\views\operating\productOperations\index.vue

    const cpspId = isVnoAccount ? useCommon().userData.cid[0] : Number(sessionStorage.getItem('productOperationsCid'));
    const languageList = ref([]);
    const sysDictList = ref([{
      label: t('全部'),
      value: ''
    }]);
    const enList = ref([]);
    const selectedChannelIdList = ref([]);
    const selectedChannel = ref([]);
    const operatorList = ref([]); //操作用户列表

    const ReviewStatus = {
      '0': t('未审核'),
      '1': t('已审核'),
      '2': t('未通过'),
      '3': t('终端审核'),
      '4': t('退回审核')
    };
    const ReleaseStatus = {
      '0': t('未上线'),
      '1': t('已上线'),
      '2': t('已下线')
    };
    const stateList = [{
      label: t('全部'),
      value: ''
    }, {
      label: t('未审核'),
      value: 0
    }, {
      label: t('已审核'),
      value: 1
    }, {
      label: t('未通过'),
      value: 2
    }, {
      label: t('终端审核'),
      value: 3
    }, {
      label: t('退回审核'),
      value: 4
    }];
    const releaseStateList = [{
      label: t('全部'),
      value: ''
    }, {
      label: t('未上线'),
      value: 0
    }, {
      label: t('已上线'),
      value: 1
    }, {
      label: t('已下线'),
      value: 2
    }];

    const handleCategoryChange = val => {
      searchParams.categoryProperty = val.join(',');
      tableRef.value.commonTableRef.clearSort(); //清空排序条件

      getLiveChannelList(1, 10, searchParams);
    };

    onMounted(() => {
      getLiveChannelList(1, 10, {
        cpspId
      });
      getEnList();
      getLanguageList();
      getBrands();
      loading.value = false;
    });

    const handleSelectionChange = row => {
      selectedChannelIdList.value = [];
      selectedChannel.value = [];

      if (row.length > 0) {
        row.forEach(val => {
          selectedChannelIdList.value.push(val.id);
          selectedChannel.value.push(val);
        });
      }

      console.log('选择的频道', selectedChannel.value);
    };

    const searchConfig = reactive({
      labelWidth: '90px',
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '关键字筛选',
        prop: 'keyWord',
        widgetType: 'input'
      }, {
        label: '语言',
        prop: 'lang',
        widgetType: 'Select',
        multiple: true,
        collapseTags: true,
        list: languageList,
        valueKey: 'label'
      }, {
        label: '上线状态',
        prop: 'releaseState',
        widgetType: 'Select',
        list: releaseStateList,
        valueKey: 'value'
      }, {
        label: '审核状态',
        prop: 'state',
        widgetType: 'Select',
        list: stateList,
        valueKey: 'value'
      }, {
        label: '创建时间',
        prop: 'createTime',
        widgetType: 'date',
        type: 'daterange',
        valueFormat: 'x'
      }, {
        label: '操作用户',
        prop: 'operatingUser',
        widgetType: 'Select',
        placeholder: '请选择操作用户',
        labelKey: 'name',
        valueKey: 'id',
        list: [{
          name: t('全部'),
          id: ''
        }]
      }],
      formData: {
        operatingUser: '',
        releaseState: '',
        state: ''
      }
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: 0
      },
      isShowHeader: false,
      headerButtonsList: []
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection'
      }, {
        label: '序号',
        prop: 'no',
        align: 'left',
        width: '60px'
      }, {
        label: '频道名称',
        prop: 'name',
        align: 'left',
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        width: 160
      }, {
        label: '节目识别号',
        prop: 'callSign',
        align: 'left',
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: '语言',
        prop: 'language',
        align: 'left',
        width: '125px',
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: '审核状态',
        prop: 'state',
        align: 'left',
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => ReviewStatus[value]
      }, {
        label: '上线状态',
        prop: 'releaseState',
        align: 'left',
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => ReleaseStatus[value]
      }, {
        label: '分类属性',
        prop: 'categoryProperty',
        align: 'left',
        sortable: 'custom',
        width: 120,
        'sort-orders': ['ascending', 'descending']
      }, {
        label: '操作用户',
        prop: 'operatorName',
        align: 'left',
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => {
          return value === null ? '/' : value;
        }
      }, {
        label: '创建时间',
        prop: 'createTime',
        align: 'left',
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => getCurrentTime(value)
      }]
    }); // 分页size变化的回调

    const sizeChange = size => {
      loading.value = true;
      tableConfig.paginationConfig.limit = size;
      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('productOperationsCid'); //运营商id

      params = { ...params,
        ...searchParams,
        ...sortParams
      };
      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    }; // 页码变化的回调


    const currentChange = page => {
      loading.value = true;
      tableConfig.paginationConfig.page = page;
      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('productOperationsCid'); //运营商id

      params = { ...params,
        ...searchParams,
        ...sortParams
      };
      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    }; // 获取直播频道列表


    const getLiveChannelList = async (pageNo = 1, pageSize = 5, params = {}, orderBy = '', orderType = '') => {
      loading.value = true; // excludeChannelCategoryId （int）用于过滤已经添加的节目

      params.excludeChannelCategoryId = props.pageParams.categoryId; // programType 品牌的编码标准  0:h264 1:h265

      params.programType = props.pageParams.programType == 0 ? 0 : '';
      const {
        code,
        data
      } = await getLiveChannelListApi(pageNo, pageSize, params);

      if (code === '0') {
        tableConfig.data = data.records.map((item, index) => {
          return { ...item,
            no: (pageNo - 1) * pageSize + index + 1 // 序号

          };
        });
        tableConfig.paginationConfig.page = data.current;
        tableConfig.paginationConfig.total = data.total;
        tableConfig.paginationConfig.limit = data.size;
      }

      loading.value = false;
    }; // 获取语言列表


    const getLanguageList = async () => {
      const {
        code,
        data
      } = await getLanguageListApi();

      if (code === '0') {
        languageList.value = [...languageList.value, ...data];
      }
    }; // 获取分类属性列表


    const getEnList = async () => {
      const {
        code,
        data
      } = await getEnListApi(cpspId);

      if (code === '0') {
        enList.value = [...enList.value, ...data];
      }
    }; // 获取品牌选项数据


    const getBrands = async () => {
      const brands = await useBrandsByUser();
      let searchItem = getItemByProp(searchConfig.formList, 'cid');
      if (searchItem) searchItem.list = brands;
      getUserByCid({
        cid: cpspId || brands[0].cid
      });
    }; // 获取操作用户


    const getUserByCid = async params => {
      const res = await getUserByCidApi(params);
      console.log('getUserByCidApi', res);

      if (res.code == '0') {
        let item = getItemByProp(searchConfig.formList, 'operatingUser');
        item.list = [...item.list, ...res.data];
        operatorList.value = [...res.data];
      }
    }; // 搜索按钮的回调


    let searchParams = reactive({
      cpspId
    });

    const handleSearch = formData => {
      console.log('search', formData); // 整理数据

      for (let key in formData) {
        switch (key) {
          case 'releaseState':
            searchParams.releaseState = formData[key];
            break;

          case 'state':
            searchParams.state = formData[key];
            break;

          case 'createTime':
            searchParams.beginTime = transferTime(formData[key][0]);
            searchParams.endTime = transferTime(formData[key][1]);
            break;

          case 'keyWord':
            searchParams.keyword = formData[key];
            break;

          case 'lang':
            if (formData[key].length === 0) {
              searchParams.language = '';
            } else {
              searchParams.language = formData[key].includes(t('全部')) ? '' : formData[key].toString();
            }

            break;

          case 'operatingUser':
            searchParams.operator = formData[key];
            break;
        }
      }

      console.log('searchParams', searchParams); // 整理searchParams

      for (let key in searchParams) {
        if (searchParams[key] === '' || searchParams[key].length === 0) {
          delete searchParams[key];
        }
      }

      if (categories.value.length > 0) {
        searchParams.categoryProperty = categories.value.join(',');
      } // 具备查询条件 区分当前tag是否为全部


      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('productOperationsCid'); //运营商id

      searchParams.cpspId = cid;
      params = { ...params,
        ...searchParams,
        ...sortParams
      };
      tableRef.value.commonTableRef.clearSort(); //清空排序条件

      getLiveChannelList(1, 10, params);
    }; // 重置按钮的回调


    const handleReset = () => {
      tableConfig.data = [];
      categories.value = [];
      searchParams = reactive({
        cpspId
      });
      searchConfig.formData = {
        operatingUser: '',
        releaseState: '',
        state: ''
      };
      sortParams.orderBy = undefined;
      sortParams.orderType = undefined;
      tableRef.value.commonTableRef.clearSort(); //清空排序条件

      enList.value = [];
      languageList.value = [];
      getEnList();
      getLanguageList();
      getLiveChannelList(1, 10, {
        cpspId
      });
    };

    const handleSortChange = sortType => {
      sortParams.orderBy = sortType.prop ? sortType.prop : undefined;

      if (sortType.order) {
        sortParams.orderType = sortType.order === 'ascending' ? 'ASC' : 'DESC';
      } else {
        sortParams.orderType = undefined;
      }

      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      params = {
        cpspId: cid,
        ...sortParams,
        ...searchParams
      };
      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    };

    const onCancel = () => {
      props.returnBackFn();
    };

    const onConfirm = () => {
      console.log('确定', selectedChannel.value);
      if (selectedChannel.value.length === 0) return ElMessage({
        type: 'error',
        message: t('请至少选择一个频道')
      });
      let channelIds = selectedChannel.value.map(item => item.id);
      addCategoryChannelApi({
        id: Number(props.pageParams.categoryId),
        channelIds
      }).then(res => {
        if (res.code == 0) {
          props.returnBackFn();
        }
      }).catch(err => console.log(err));
    };

    watch(() => tableConfig.data, val => {
      nextTick(() => {
        const columntree = document.querySelector('#columntree');
        columntree.style.maxHeight = tableWarpRef.value.offsetHeight == 583 ? '535px' : tableWarpRef.value.offsetHeight + 'px';
      });
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      const _component_column = _resolveComponent("column");

      const _component_el_button = _resolveComponent("el-button");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        gutter: 30,
        onSearch: handleSearch,
        onReset: handleReset
      }, null, 8, ["form-list", "form-data", "size"]), _createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("div", _hoisted_3, [_createElementVNode("header", null, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('分类属性')), 1), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_checkbox_group, {
        modelValue: categories.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => categories.value = $event),
        onChange: handleCategoryChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enList.value, category => {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            label: category.label,
            key: category.value,
            style: {
              "display": "block",
              "padding-top": "10px",
              "margin-left": "20%"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(category.label), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, isShowAside.value]]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "table-list",
        ref_key: "tableWarpRef",
        ref: tableWarpRef
      }, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        ref_key: "tableRef",
        ref: tableRef,
        onSizeChange: sizeChange,
        onCurrentChange: currentChange,
        onSelectionChange: handleSelectionChange,
        onSortChange: handleSortChange
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "default",
          onClick: onCancel,
          style: {
            "width": "120px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('取消')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onConfirm,
          style: {
            "width": "120px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config"])], 512)])])])), [[_directive_loading, loading.value]])], 64);
    };
  }

});